import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  Component,
  DestroyRef,
  effect,
  inject,
  input,
  model,
  output,
  signal,
} from '@angular/core';
import { TagVariant } from '../tag/tag-variant.enum';

@Component({
  standalone: true,
  selector: 'ct-lib-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
  host: {
    '[class.active]': 'active()',
  },
  animations: [
    trigger('tab', [
      state(
        'open',
        style({
          opacity: '1',
          transform: 'inherit',
        }),
      ),
      state(
        'closed',
        style({
          opacity: '0',
          transform: 'scale(0.995)',
        }),
      ),
      transition('closed => open', [animate('0.3s ease')]),
      transition('open => closed', [animate('0.3s ease')]),
    ]),
  ],
})
export class TabComponent {
  private destroyRef = inject(DestroyRef);
  private isDestroyed = signal<boolean>(false);

  public label = input.required<string>();
  public labelCounter = input<number | null>(null);
  public tag = input<{ label: string; type: TagVariant } | null>(null);
  public active = model<boolean>(false);

  public onOpen = output<void>();
  public onClose = output<void>();
  public onOpenEnd = output<void>();
  public onCloseEnd = output<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.isDestroyed.set(true);
    });

    effect(() => {
      this.toggleActiveClass(this.active());
    });
  }

  toggleActiveClass(toggle: boolean) {
    if (this.isDestroyed()) return;
    toggle ? this.onOpen.emit() : this.onClose.emit();
  }

  handleAnimationDone(isActive: boolean) {
    if (this.isDestroyed()) return;
    isActive ? this.onOpenEnd.emit() : this.onCloseEnd.emit();
  }
}
